import { render, staticRenderFns } from "./SearchResultModal.vue?vue&type=template&id=f1a19610&scoped=true"
import script from "./SearchResultModal.vue?vue&type=script&lang=js"
export * from "./SearchResultModal.vue?vue&type=script&lang=js"
import style0 from "./SearchResultModal.vue?vue&type=style&index=0&id=f1a19610&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a19610",
  null
  
)

export default component.exports